export enum ClusterType {
    PRODUCT_VOUCHER = 'PRODUCT_VOUCHER',
    FLEXIBLE_VOUCHER = 'FLEXIBLE_VOUCHER',
}
